import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

// COMPONENTS Import
import Footer from "../../../../components/LandingPage/Footer";

// SVG Imports
import BackToTop from "../../../../assets/landingPage/TopArrow.svg";
import termsimage from "../../../../assets/Landing/terms.png";

// MUI Import
import { CircularProgress, Typography } from "@mui/material";

const TermsConditions = () => {
  // useState
  const [isVisible, setIsVisible] = useState(false);
  const [scrollPercent, setScrollPercent] = useState(0);

  // useSelector
  const { mobilestatus, webstatus } = useSelector(
    (state) => state.landingpagestate,
  );

  // useEffect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20 || document.documentElement.scrollTop > 20) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      let scrollTop = window.scrollY;
      let docHeight = document.documentElement.scrollHeight;
      let winHeight = window.innerHeight;
      let scrollPercentt = scrollTop / (docHeight - winHeight);
      let scrollPercentRounded = Math.round(scrollPercentt * 100);
      setScrollPercent(scrollPercentRounded);
    });
  }, [scrollPercent]);

  useEffect(() => {
    window.onload = function () {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 50);
      setScrollPercent(0);
    };
  }, []);

  function CircularProgressWithLabel(props) {
    return (
      <div sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress
          size="59px"
          sx={{ color: "var(--pending)" }}
          variant="determinate"
          {...props}
        />
        <div
          sx={{
            zIndex: 999,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: "text.secondary" }}
          >
            <img
              src={BackToTop}
              alt="back to top"
              width="50"
              style={{ right: "45px", position: "fixed", bottom: "34px" }}
            />
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div>
        {isVisible && (
          <div
            onClick={scrollToTop}
            className="fixed bottom-[25px] right-[40px] cursor-pointer z-20"
          >
            <CircularProgressWithLabel value={scrollPercent} />
          </div>
        )}
        <>
          <div
            style={{
              overflow: webstatus ? "hidden" : "",
              overflowY: mobilestatus && "hidden",
              height: "100vh",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              WebkitOverflowScrolling: "touch",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="flex flex-col justify-center items-center relative pt-[88px] bg-[#1d3a6d] flex-1">
              <div className="h-full max-w-[1024px] w-screen flex justify-center mx-auto relative flex-col">
                <div className="text-center">
                  <h2 className="text-font-xl pb-2 text-text-primary font-semibold">
                    Terms and <span className="text-pending">Conditions</span>
                  </h2>
                </div>

                <div className="w-full flex flex-col md:flex-row items-center py-5 px-5">
                  <div className="w-full md:w-1/2 order-1 md:order-2">
                    <img
                      className="landingimg mx-auto"
                      src={termsimage}
                      alt="Terms and Conditions"
                    />
                  </div>
                  <div className="text-text-secondary w-full md:w-1/2 mt-4 md:mt-0 md:pl-5 order-2 md:order-1">
                    Using the functionality and services offered on this website
                    means that you accept all of the terms and conditions
                    contained in the User Agreement signed between the
                    Corporation and Xpentra technologies Pvt Ltd.
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="flex flex-1 bg-[#1d3a6d]"></div> */}
            <Footer />
          </div>
        </>
      </div>
    </div>
  );
};

export default TermsConditions;
